import React, { useState, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import PropTypes from 'prop-types';
import { deleteReportingCategory } from '../../../../store/products/products.api';
import DeleteReportingCategoryModal from '../delete-reporting-category-modal';
import messages from '../messages';

export const DeleteButton = ({ categoryId, needsReload, setNeedsReload }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openDeleteModal = () => setIsModalOpen(true);
  const closeDeleteModal = () => setIsModalOpen(false);
  const onDelete = useCallback(() => {
    const deleteReportingCategoryPromise = deleteReportingCategory(categoryId);
    deleteReportingCategoryPromise.promise.then(() => {
      setIsModalOpen(false);
      setNeedsReload(!needsReload);
    });
    return () => deleteReportingCategoryPromise?.cancel();
  }, [categoryId, needsReload, setNeedsReload]);

  return (
    <>
      <Button onClick={openDeleteModal} theme='link'>
        <FormattedMessage {...messages.deleteCategoryButton} />
      </Button>
      {isModalOpen && <DeleteReportingCategoryModal onClose={closeDeleteModal} onDelete={onDelete} />}
    </>
  );
};

DeleteButton.propTypes = {
  categoryId: PropTypes.string.isRequired,
  needsReload: PropTypes.bool.isRequired,
  setNeedsReload: PropTypes.func.isRequired,
};
